import { createSlice } from '@reduxjs/toolkit';
import { fetchAuditLogs } from './auditThunk';

const initialState = {
  logs: { data: [], total: 0 },
  status: 'idle',
  error: null,
};

const auditSlice = createSlice({
  name: 'audit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.logs.data = action.payload.data;
        state.logs.total = action.payload.total;
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default auditSlice.reducer;